export const SCRIPT_BUNDLE =
  'https://chat-assets.frontapp.com/v1/chat.bundle.js';
